
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upsc-prelims-hallticket",
      function () {
        return require("private-next-pages/upsc-prelims-hallticket/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upsc-prelims-hallticket"])
      });
    }
  